import {AfterViewInit, Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {appConfig} from '../../../../config/config';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatDialog} from '@angular/material/dialog';
import {PageRequest} from '../../../../shared/models/page-request.interface';
import {ErrorMargins} from '../../../models/error-margins.interface';
import {EditErrorComponent} from '../edit-error/edit-error.component';

@Component({
  selector: 'app-error-margins-table',
  templateUrl: './error-margins-table.component.html',
  styleUrls: ['./error-margins-table.component.scss']
})
export class ErrorMarginsTableComponent implements AfterViewInit {

  pageSizes = appConfig.pageSizes;
  displayedColumns: string[] = ['id', 'key-figures', 'percentage', 'edit'];

  @Input()
  errors!: ErrorMargins[];
  @Input()
  page!: number;
  @Input()
  pageSize = 100;
  @Input()
  totalElements!: number;

  @Output()
  loadErrors: EventEmitter<PageRequest> = new EventEmitter<PageRequest>();

  @ViewChild(MatPaginator)
  paginator!: MatPaginator;

  @ViewChild(MatSort)
  sort!: MatSort;

  constructor(private readonly dialog: MatDialog) { }

  ngAfterViewInit(): void {
    this.sort.sortChange.subscribe(() => this.onSortChange(this.sort.active, this.sort.direction));
  }

  onSortChange(active: string, direction: string): void {
    this.loadErrors.emit({page: 0, size: this.pageSize, sort: active, direction});
  }

  onPageChange(event: PageEvent): void {
    this.loadErrors.emit({page: event.pageIndex, size: event.pageSize});
  }

  editError(value: ErrorMargins): void {
    const dialogRef = this.dialog.open(EditErrorComponent, {data: value, maxWidth: 400, width: 'inherit'});

    dialogRef.componentInstance.updateEvent.subscribe(() => {
      this.loadErrors.emit({page: this.paginator.pageIndex, size: this.paginator.pageSize});
    });
  }

}
